import { TournamentDrawsComponent } from './tournament-draws/tournament-draws.component';
import { OfficialsComponent } from './../../_shared/components/officials/officials.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TournamentDetailsComponent } from './tournament-details.component';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { TieMatchScoreboardModule } from '../../ties/tie-details/tie-match-list/tie-match-scoreboard/tie-match-scoreboard.module';
import { ShareMatchComponentModule } from '../../_shared/components/share-match/share-match.module';
import { TournamentMenuComponent } from './tournament-menu/tournament-menu.component';
import { SelectUserModule } from '../../_shared/components/select-user/select-user.module';
import { TrackersModule } from '../../_shared/components/trackers/trackers.module';
import { TournamentDetailsRoundModule } from './tournament-details-routing.module';
import { LiveScoreComponent } from './live-score/live-score.component';
import { TournamentHeaderComponent } from './tournament-header/tournament-header.component';
import { LoginModalModule } from '../../_shared/components/login-modal/login-modal.module';
import { AdsModule } from '../../_shared/components/ads/ads.module';
import { ParticipantListComponent } from '../../participant-list/participant-list.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TournamentDetailsRoundModule,
        TranslateModule.forChild(),
        EmptyPageModule,
        TieMatchScoreboardModule,
        ShareMatchComponentModule,
        ReactiveFormsModule,
        SelectUserModule,
        TrackersModule,
        LoginModalModule,
        AdsModule,
        OfficialsComponent,
        ParticipantListComponent,
        TournamentHeaderComponent,
        TournamentDrawsComponent
    ],
    declarations: [
        TournamentDetailsComponent,
        TournamentMenuComponent,
        LiveScoreComponent,
    ]
})
export class TournamentDetailsModule { }
